export const formatTime = (hour) => {
    const hourNum = parseInt(hour.split(':')[0], 10)
    const minuteNum = hour.split(':')[1]
    const suffix = hourNum >= 12 ? ' PM' : ' AM'
    hour = `${((hourNum + 11) % 12) + 1}:${minuteNum}${suffix}`
    return hour
}
